import { useProfileData } from "../../../hooks/useProfileData";

const useIsOwnProfile = ({ entityId, isEntityIdLoading }: { entityId?: number; isEntityIdLoading: boolean }) => {
  const {
    data: { entityId: entityIdFromProfileData },
    isLoading: isProfileDataLoading,
  } = useProfileData();

  return {
    isOwn: entityId === entityIdFromProfileData,
    isLoading: isProfileDataLoading || isEntityIdLoading,
  };
};

export default useIsOwnProfile;
